interface RatingStarsProps {
  rating: number;
  className?: string;
  showValue?: boolean;
  size?: 'sm' | 'md';
}

export default function RatingStars({
  rating,
  className = '',
  showValue = true,
  size = 'sm',
}: RatingStarsProps) {
  const five = rating / 2;
  const iconSize = size === 'sm' ? 'text-[13px]' : 'text-base';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-0.5" aria-label={`评分 ${rating} 分`}>
        {[1, 2, 3, 4, 5].map((i) => {
          let icon = 'ri-star-line text-foreground-300';
          if (five >= i) icon = 'ri-star-fill text-accent-500';
          else if (five >= i - 0.5) icon = 'ri-star-half-fill text-accent-500';
          return (
            <i key={i} className={`${icon} ${iconSize} w-[14px] h-[14px] flex items-center justify-center`}></i>
          );
        })}
      </div>
      {showValue && (
        <span className="text-sm font-semibold text-accent-600 tabular-nums">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
}